import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App.jsx';
import { registerServiceWorker } from '@/lib/pwa';
import { initSync } from '@/lib/syncEngine';
import '@/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// Register the PWA service worker (no-op in dev mode)
registerServiceWorker();

// Start the offline outbox sync engine (drains queued ops when online).
initSync();
